<template>
  <div class="error-wrapper" :class="{ 'error-wrapper--checkbox': checkbox }">
    <transition-group class="error-items" name="fade-up">
      <xMark v-if="error" key="icon" />

      <span v-if="error" key="error" class="error" v-text="error" />
    </transition-group>
  </div>
</template>

<script>
import xMark from '@/components/common/X-Mark'

export default {
  components: {
    xMark
  },
  props: {
    error: {
      type: String,
      default: ''
    },
    checkbox: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.error-wrapper {
  display: block;

  position: absolute;
  left: 0;
  bottom: -15px;

  @include media-down(xl) {
    bottom: -15px;
  }

  @include media-down(lg) {
    bottom: -30px;
  }

  @include media-down(md) {
    bottom: -15px;
  }

  &--checkbox {
    left: $checkbox-size + 22px;
    bottom: -18px;

    @include media-down(lg) {
      bottom: -40px;
    }

    @include media-down(md) {
      bottom: -25px;
    }
  }
}

.error-items {
  @include center-content;
}

.error {
  color: $label-color;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 10px;

  filter: contrast(1.7);

  @include media-down(xl) {
    font-size: 9px;
  }

  @include media-down(lg) {
    font-size: 21px;
  }

  @include media-down(md) {
    font-size: 10px;
  }
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-up-enter {
  opacity: 0;
  transform: translate3d(0, calc(100% - 8px), 0);
}

.fade-up-leave-to {
  opacity: 0;
  transform: translate3d(0, calc(100% + 6px), 0);
}
</style>
